export const info = [
  {
      name: "status",
      description: "Shows the status information of the Bot",
      type: 1
  },
  {
      name: "developer",
      description: "Shows the developer information of the Bot (Credit)",
      type: 1
  },
  {
      name: "invite",
      description: "Shows the invite information of the Bot",
      type: 1
  },
  {
      name: "ping",
      description: "Shows the ping information of the Bot",
      type: 1
  }
]